import { Button, Image, Typography, Dropdown, Modal } from 'antd';
import {
    CheckIcon,
    coppywriting,
    PauseIcon,
    ThreeDots, // Import ThreeDots icon
} from 'assets';
import { useProfile } from 'hooks';
import { useToggleScreenRecord } from 'hooks/screen-record';
import { customerLookupMessages } from 'messages/customer-lookup.message';
import { AGENT_STATUS } from 'utils';

interface CreatingTicketProps {
    isMinimized: boolean;
    toggleAgentStatus: (status: AGENT_STATUS.AGENT_PAUSED | AGENT_STATUS.AGENT_UNPAUSED) => void;
    isTogglingStatus: boolean; // New prop
    showPauseReasonModal: boolean;
    setShowPauseReasonModal: (value: boolean) => void;
    customerPhoneNumber?: string; // Add new prop for customer phone number
}

const CreatingTicketContent: React.FC<CreatingTicketProps> = ({ isMinimized, toggleAgentStatus, isTogglingStatus, showPauseReasonModal, setShowPauseReasonModal, customerPhoneNumber }) => {
    const { profile } = useProfile();
    const { onToggleScreenRecordHandle } = useToggleScreenRecord()

    // Dedicated handlers
    const handleReadyStatus = () => {
        localStorage.removeItem("isAgentCreatingTicket");
        toggleAgentStatus(AGENT_STATUS.AGENT_UNPAUSED);
        onToggleScreenRecordHandle({
            "isRec": false,
        }).then(response => {

        })
            .catch(error => {
                console.error('❌ Failed to start screen recording:', error);
            });
    };

    // Define action items for the dropdown menu
    const actionItems = [
        // {
        //     key: 'ready',
        //     label: customerLookupMessages.readyV2
        // },
        {
            key: 'busy',
            label: customerLookupMessages.busy
        }
    ];

    // Handle action item click
    // const onClickActionItem = (key: string) => {
    //     const isReady = key === 'ready';
    //     Modal.confirm({
    //         title: 'Xác nhận chuyển trạng thái',
    //         content: isReady
    //             ? 'Chuyển sang Sẵn sàng sẽ xóa hết thông tin đang tạo phiếu'
    //             : 'Chuyển sang Bận sẽ xóa hết thông tin đang tạo phiếu',
    //         okText: 'Xác nhận',
    //         cancelText: 'Hủy',
    //         onOk: () => {
    //             if (isReady) handleReadyStatus();
    //             else {
    //                 setShowPauseReasonModal(true);
    //             }
    //         }
    //     });
    // };
    const onClickActionItem = (key: string) => {
        Modal.confirm({
            title: 'Xác nhận chuyển trạng thái',
            content: 'Chuyển sang Bận sẽ xóa hết thông tin đang tạo phiếu',
            okText: 'Xác nhận',
            cancelText: 'Hủy',
            onOk: () => {
                localStorage.removeItem("isAgentCreatingTicket");
                setShowPauseReasonModal(true);
            }
        });
    };

    // Handle ready button click with Modal.confirm
    const handleReadyButtonClick = () => {
        Modal.confirm({
            title: "Xác nhận chuyển trạng thái",
            content: "Chuyển trạng thái sẵn sàng sẽ xóa hết thông tin khách hàng đã tìm kiếm",
            okText: "Xác nhận",
            cancelText: "Hủy",
            onOk: handleReadyStatus
        });
    };

    return (
        <div className="w-[400px] flex h-[244px] flex-col rounded-tl-xl">
            <div className="m-5 flex flex-col">
                <div className="flex flex-row items-center justify-between">
                    <div className="flex flex-col">
                        <Typography.Text className="text-left text-[12px]/[16px] font-semibold tracking-normal text-[#868D87]">
                            EXT #{profile?.extensionId || ''}
                        </Typography.Text>
                        <Typography.Text className="mt-3 text-left font-semibold tracking-normal text-[#000000] opacity-100">
                            {customerLookupMessages.CreatingTicket}
                        </Typography.Text>
                    </div>
                    <Image src={coppywriting} className="h-[58px] w-[58px]" alt="coppywriting" />
                </div>
                <Typography.Text className="mt-3 text-left text-[16px]/[20px] tracking-normal text-[#141414] opacity-100">
                    {customerPhoneNumber
                        ? <>Số điện thoại gọi đến <span className="text-blue-600 font-semibold">{customerPhoneNumber}</span></>
                        : customerLookupMessages.isCreatingTicket}
                </Typography.Text>
                <div className="flex items-center">
                    <Button
                        style={{ borderColor: "#06A77D" }}
                        className="mt-9 h-9 w-[170px] mr-2"
                        icon={<CheckIcon />}
                        disabled={isTogglingStatus}
                        loading={isTogglingStatus}
                        onClick={handleReadyButtonClick}
                    >
                        <Typography.Text className="text-left text-[14px]/[18px] font-semibold tracking-normal text-[#06A77D]">
                            {customerLookupMessages.ready}
                        </Typography.Text>
                    </Button>

                    <Dropdown
                        trigger={['click']}
                        menu={{
                            items: actionItems,
                            onClick: ({ key }) => onClickActionItem(key),
                        }}
                        openClassName='border-colorPrimaryActive'
                    >
                        <Button style={{ borderColor: "#EBEBED", }} className="mt-9 h-9" type='text' loading={isTogglingStatus}>
                            <ThreeDots />
                        </Button>
                    </Dropdown>
                </div>
            </div>
        </div>
    )
};

export default CreatingTicketContent;
